import { ManufacturingLifecycleStatus } from '../../constants/manufacturing-lifecycle-status.js';
import { MANUFACTURING_TERMINAL_STATUS_IDS } from './terminal-status-ids.js';
/**
 * The statuses a job or ticket is still live at — everything but the two terminal ones.
 *
 * Named for liveness rather than borrowed from `MANUFACTURING_ORDER_SCHEDULE_EDITABLE_STATUS_IDS`,
 * which answers an editing question and only coincides with this one today: the board's Overdue
 * and Unscheduled tiles are counted server-side as `NOT IN (terminal)`, so a future rule locking a
 * running job's schedule would silently stop the board counting in-progress jobs.
 */
export const MANUFACTURING_LIVE_STATUS_IDS = Object.values(ManufacturingLifecycleStatus)
    .filter((value) => typeof value === 'number')
    .filter((status) => !MANUFACTURING_TERMINAL_STATUS_IDS.includes(status));
//# sourceMappingURL=live-status-ids.js.map